// extracted by mini-css-extract-plugin
module.exports = {"date":"_8e0148e","section":"_d288c48","row":"_ff6f8dc","cell":"_9f7d041","label":"_92a3481"};